<div class="verify-code-modal">
  <button
    class="close-btn"
    mat-icon-button
    (click)="close()"
  >
    <mat-icon>close</mat-icon>
  </button>
  <div class="big-icon">
    <img src="assets/core/e-sign/push_notifications.svg" />
  </div>
  <div class="title">Enter your verification code</div>
  <div class="message">We send a verification code to {{ data.phone }}</div>
  <div
    class="otp-container"
    #otpRef
    fxLayoutGap="8px"
  >
    <input
      class="otp-input"
      (input)="inputInsideOtpInput($event)"
      type="number"
      placeholder="X"
    />
    <input
      class="otp-input"
      (input)="inputInsideOtpInput($event)"
      type="number"
      placeholder="X"
    />
    <input
      class="otp-input"
      (input)="inputInsideOtpInput($event)"
      type="number"
      placeholder="X"
    />
    <input
      class="otp-input"
      (input)="inputInsideOtpInput($event)"
      type="number"
      placeholder="X"
    />
    <input
      class="otp-input"
      (input)="inputInsideOtpInput($event)"
      type="number"
      placeholder="X"
    />
    <input
      class="otp-input"
      (input)="inputInsideOtpInput($event)"
      type="number"
      placeholder="X"
    />
  </div>
  <mat-error
    class="error-message"
    *ngIf="notValid"
    >The OTP Code does not match
  </mat-error>
  <mat-error
    class="error-message"
    *ngIf="reachedMax"
    >The max verification request has been reached. \n Please try again after 10 minutes
  </mat-error>
  <button
    class="submit-btn"
    mat-button
    class="cimb-button--primary"
    (click)="submit()"
    [disabled]="!canSubmit || reachedMax"
  >
    Submit
  </button>
  <div class="message">
    Didn't receive a code?
    <a
      class="resend"
      [ngClass]="{ disabled: !(countSendingOTP < 5) || reachedMax }"
      (click)="sendOTP()"
      >Resend</a
    >
  </div>
</div>
